import { TOKEN_STORAGE_KEY, WORKSPACE_STORAGE_KEY, THEME_STORAGE_KEY } from './env';

const LEGACY_KEYS: Record<string, string> = {
  'zaag-studio.token': TOKEN_STORAGE_KEY,
  'zaag-studio.workspaceId': WORKSPACE_STORAGE_KEY,
  'zaag-studio.theme': THEME_STORAGE_KEY,
};

/** One-time carry-over from the pre-rebrand `zaag-studio.*` keys so existing sessions survive the deploy. */
export function migrateLegacyStorageKeys(): void {
  for (const [oldKey, newKey] of Object.entries(LEGACY_KEYS)) {
    const oldValue = localStorage.getItem(oldKey);
    if (oldValue === null) continue;
    if (localStorage.getItem(newKey) === null) {
      localStorage.setItem(newKey, oldValue);
    }
    localStorage.removeItem(oldKey);
  }
}
